import HrLayout from "./layouts/HrLayout";
import PhLayout from "./layouts/PhLayout";
import DefaultLayout from "./layouts/DefaultLayout";

import { Login } from "./pages";
/* Hotel Representative */
import HrFirstLogin from "./pages/hotelRepresentative/HrFirstLogin";
import HrDashboard from "./pages/hotelRepresentative/HrDashboard";
import HrGetCertified from "./pages/hotelRepresentative/HrGetCertified";
import HrPhotoshootRequirementForm from "./pages/hotelRepresentative/HrPhotoshootRequirementForm";
import HrManagePhotoshoots from "./pages/hotelRepresentative/HrManagePhotoshoots";
import HrPhotoshootDetails from "./pages/hotelRepresentative/HrPhotoshootDetails";
/* Photographer */
import PhDashboard from "./pages/photographer/PhDashboard";
import PhGetCertified from "./pages/photographer/PhGetCertified";
import PhPhotoshootRequest from "./pages/photographer/PhPhotoshootRequest";
import PhManagePhotoshoots from "./pages/photographer/PhManagePhotoshoots";
import PhPhotoshootDetails from "./pages/photographer/PhPhotoshootDetails";
import PhViewFeedback from "./pages/photographer/PhViewFeedback";
import ChangePassword from "./pages/photographer/ChangePassword";

import Utils from "./Utils";

const CustomRoutes = [
  {
    path: "/",
    secure: false,
    exact: true,
    layout: DefaultLayout,
    component: Login,
  },
  /* Routing for Hotel Representative */
  {
    path: "/hotel-representative-first-login",
    secure: false,
    exact: true,
    layout: DefaultLayout,
    component: HrFirstLogin,
  },
  {
    path: "/hotel-representative-dashboard",
    secure: true,
    exact: true,
    layout: HrLayout,
    component: HrDashboard,
  },
  {
    path: "/hotel-representative-get-certified",
    secure: true,
    exact: true,
    layout: HrLayout,
    component: HrGetCertified,
  },
  {
    path: "/hotel-representative-photoshoot-requirement-form",
    secure: true,
    exact: true,
    layout: HrLayout,
    component: HrPhotoshootRequirementForm,
  },
  {
    path: "/hotel-representative-manage-photoshoots",
    secure: true,
    exact: true,
    layout: HrLayout,
    component: HrManagePhotoshoots,
  },
  {
    path: "/hotel-representative-photoshoot-details/:id",
    secure: true,
    exact: true,
    layout: HrLayout,
    component: HrPhotoshootDetails,
  },
  /* Routing for Photographer */
  {
    path: "/photographer-dashboard",
    secure: true,
    exact: true,
    layout: PhLayout,
    component: PhDashboard,
  },
  {
    path: "/photographer-get-certified",
    secure: true,
    exact: true,
    layout: PhLayout,
    component: PhGetCertified,
  },
  {
    path: "/photographer-photoshoot-request/:id",
    secure: true,
    exact: true,
    layout: PhLayout,
    component: PhPhotoshootRequest,
  },
  {
    path: "/photographer-manage-photoshoots",
    secure: true,
    exact: true,
    layout: PhLayout,
    component: PhManagePhotoshoots,
  },
  {
    path: "/photographer-photoshoot-details/:id",
    secure: true,
    exact: true,
    layout: PhLayout,
    component: PhPhotoshootDetails,
  },
  {
    path: "/photographer-view-feedback/:psid/:origid",
    secure: true,
    exact: true,
    layout: DefaultLayout,
    component: PhViewFeedback,
  },
  {
    path: "/photographer-view-feedback/:psid/:origid/:fname",
    secure: true,
    exact: true,
    layout: DefaultLayout,
    component: PhViewFeedback,
  },
  {
    path: "/change-password",
    secure: true,
    exact: true,
    layout: PhLayout,
    component: ChangePassword,
  },
];

export default CustomRoutes;
